/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Head_Catalog_TitleInputs */

const en_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API Catalog - AnyAPI`)
};

const zh_hans1_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API 目录 - AnyAPI`)
};

const pt_br2_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo de APIs - AnyAPI`)
};

const es_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catálogo de APIs - AnyAPI`)
};

const fr_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogue d’API - AnyAPI`)
};

const de_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`API-Katalog | AnyAPI`)
};

const ru_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каталог API - AnyAPI`)
};

const it_head_catalog_title = /** @type {(inputs: Head_Catalog_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Catalogo API - AnyAPI`)
};

/**
* | output |
* | --- |
* | "API Catalog - AnyAPI" |
*
* @param {Head_Catalog_TitleInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const head_catalog_title = /** @type {((inputs?: Head_Catalog_TitleInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Head_Catalog_TitleInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_head_catalog_title(inputs)
	if (locale === "pt-BR") return pt_br2_head_catalog_title(inputs)
	if (locale === "es") return es_head_catalog_title(inputs)
	if (locale === "fr") return fr_head_catalog_title(inputs)
	if (locale === "de") return de_head_catalog_title(inputs)
	if (locale === "ru") return ru_head_catalog_title(inputs)
	if (locale === "it") return it_head_catalog_title(inputs)
	return en_head_catalog_title(inputs)
});